import { useDispatch, useSelector } from 'react-redux';
import { Box, Button } from '@mui/material';
import { Edit, RestartAltOutlined } from '@mui/icons-material';
import { useSubmitFormMutation } from '../../giftApiSlice';
import {
  reset,
  selectEditForChanges,
  selectPreview,
  selectShowAdminHistory,
  selectShowSubmittedHistory,
  selectShowToolbar,
  setEditPreview,
} from '../../giftSlice';
const ManagerPreviewTools = () => {
  const dispatch = useDispatch();
  const [submitForm] = useSubmitFormMutation();
  const preview = useSelector(selectPreview);
  const viewForm = Boolean(preview);
  const adminHistory = useSelector(selectShowAdminHistory);
  const managerHistory = useSelector(selectShowSubmittedHistory);
  const isHistory = Boolean(adminHistory || managerHistory);
  const showToolbar = useSelector(selectShowToolbar);

  const handleEdit = () => {
    dispatch(setEditPreview({ value: true }));
  };

  const handleSubmit = () => {
    submitForm(preview);
  };
  const handleResetClick = () => {
    dispatch(reset());
  };
  return viewForm ? (
    <Box sx={{ flex: 0.05, display: isHistory ? 'none' : 'flex', border: 0, mt: 'auto' }}>
      <Button variant='outlined' size='small' endIcon={<Edit />} onClick={handleEdit}>
        Edit
      </Button>
      {/* <Button
        size='small'
        variant='outlined'
        sx={{ ml: 1 }}
        onClick={handleResetClick}
        endIcon={<RestartAltOutlined />}
      >
        Reset
      </Button> */}
      <Button variant='contained' size='small' sx={{ ml: 'auto' }} onClick={handleSubmit}>
        Update
      </Button>
    </Box>
  ) : null;
};

export default ManagerPreviewTools;
